import { tv } from 'tailwind-variants';

/**
 * Styles for the BaseCheckbox component using tailwind-variants
 * Uses design tokens for check-radio controls
 */
const baseCheckboxStyles = tv({
    slots: {
        base: `
      iris:size-(--comp-size-box-check-radio-control)
      iris:rounded-(--comp-size-radius-checkbox-control)
      iris:border
      iris:p-0.5
      iris:shadow-none
      iris:outline-none
      iris:disabled:cursor-not-allowed
      iris:disabled:opacity-(--sem-opacity-interactive-disabled)
    `,
        indicator: `
      iris:flex
      iris:h-full
      iris:w-full
      iris:text-(--comp-color-content-check-radio-control-selected)
    `,
    },
    variants: {
        inverse: {
            false: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-rest)
          iris:bg-(--comp-color-background-check-radio-control-rest)
          iris:data-[state=checked]:border-(--comp-color-border-check-radio-control-selected)
          iris:data-[state=checked]:bg-(--comp-color-background-check-radio-control-selected)
        `,
            },
            true: {
                base: `
          iris:border-(--comp-color-border-check-radio-control-inverse-rest)
          iris:bg-(--comp-color-background-check-radio-control-inverse-rest)
          iris:focus-visible:ring-(--sem-color-border-interactive-inverse-selected)
          iris:focus-visible:ring-offset-(--sem-color-background-neutral-inverse-primary)
          iris:data-[state=checked]:border-(--comp-color-border-check-radio-control-inverse-selected)
          iris:data-[state=checked]:bg-(--comp-color-background-check-radio-control-inverse-selected)
        `,
                indicator: "iris:text-(--comp-color-content-check-radio-control-inverse-selected)",
            },
        },
        error: {
            true: "iris:border-(--comp-color-border-check-radio-control-error)",
        },
        disabled: {
            true: "",
            false: "",
        },
    },
    compoundVariants: [
        {
            inverse: false,
            disabled: false,
            class: {
                base: `
          iris:hover:border-(--comp-color-border-check-radio-control-hover)
          iris:hover:bg-(--comp-color-background-check-radio-control-hover)
        `,
            },
        },
        {
            inverse: true,
            disabled: false,
            class: {
                base: `
          iris:hover:border-(--comp-color-border-check-radio-control-inverse-hover)
          iris:hover:bg-(--comp-color-background-check-radio-control-inverse-hover)
        `,
            },
        },
    ],
});

export { baseCheckboxStyles as default };
